
import workPostsQuery from "~/apollo/queries/work/posts";
import tagsQuery from "@/apollo/queries/tags/tags";
import locomotiveScrollMixin from '@/mixins/locomotiveScrollMixin';
import workQuery from "@/apollo/queries/pages/work";

export default {
  name: 'projects',
  colorMode: 'light',
  mixins: [locomotiveScrollMixin],
  data() {
    return {
      selectedTag: null,
      workPosts: null,
      work: null,
      tags: null,
    };
  },
  computed: {
    filteredWorkPosts() {
      if (!this.selectedTag) {
        return this.workPosts.data;
      }

      return this.workPosts.data.filter(post =>
        post.attributes.tags &&
        post.attributes.tags.data &&
        post.attributes.tags.data.some(tag =>
          tag.attributes.name === this.selectedTag
        )
      );
    },
  },
  async asyncData({app}) {
    const responseWorkPage = await app.apolloProvider.defaultClient.query({
      query: workQuery,
      variables: {
        locale: app.i18n.locale,
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    })

    const responseWork = await app.apolloProvider.defaultClient.query({
      query: workPostsQuery,
      variables: {
        locale: app.i18n.locale,
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    })

    const responseTags = await app.apolloProvider.defaultClient.query({
      query: tagsQuery,
      variables: {
        locale: app.i18n.locale,
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    })

    return {
      tags: responseTags.data.tags,
      workPosts: responseWork.data.workPosts,
      work: responseWorkPage.data.work
    }
  },
  methods: {
    selectTag(tagName) {
      this.selectedTag = tagName;

      this.$nextTick(() => {
        if (this.locoScroll) {
          this.locoScroll.update()
        }
      });
    },
  },
}
